import styled, { css } from 'styled-components';
import { COLOR_BLACK } from '../../../../../assets/styles/colors';
import { rgba } from 'polished';

export const InputWrapper = styled.div`
  position: relative;
  margin-left: 16px;

  @media (max-width: 450px) {
    margin-left: 0;
  }
`;

export const StateSelectSC = styled.button`
  min-width: 250px;
  height: 43px;

  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background: white;
  box-sizing: border-box;
  border: 1px solid rgba(47, 46, 65, 0.1);
  border-radius: 12px;
  padding: 8px;

  transition: all 0.2s;

  svg {
    margin-right: 15px;
    margin-left: 23px;
    transition: all 0.2s;
  }

  ${({ open }) =>
    open
      ? css`
          border: 1px solid rgba(47, 46, 65, 0.3);
          svg {
            transform: rotate(180deg);
          }
        `
      : css`
          svg {
            transform: rotate(0);
          }
        `}

  &:hover {
    border: 1px solid rgba(47, 46, 65, 0.3);
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MenuWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999;

  margin-top: 8px;
  padding-bottom: 8px;

  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0 4px 15px 0 rgba(47, 46, 65, 0.2);
`;

export const AllWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  padding: 8px 16px;
  margin-bottom: 8px;

  border-bottom: 1px solid ${rgba(COLOR_BLACK, 0.2)};
`;
